import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormsService } from '../forms.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';

import jspdf from 'jspdf';
import html2canvas from 'html2canvas';

import { FormsGlobals } from '../../../models/forms/forms.enum';
import { MessagingService } from '../../../services/messaging.service';
import { FormsSummaryComponent } from '../forms-summary/forms-summary.component';
import { PatientCaseWorkItemFormDataModel } from '../../../models/forms/data/patient-case-work-item-form-data.model';
import { FormParagraphDataModel } from '../../../models/forms/data/form-paragraph-data.model';
import { FormVersionConfigurationModel } from '../../../models/forms/form-version-configuration.model';
import { FormConfigurationModel } from '../../../models/forms/form-configuration.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { ContainerModel } from '../models/container.model';
import { NotesFromFormModel } from '../models/notes-from-form.model';
import { Globals } from '../../../globals';
import { StaticDataService } from '../../../services/static-data.service';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { FormParagraphConfigurationModel } from '../../../models/forms/form-paragraph-configuration.model';
import { Subscription } from 'rxjs';

export interface IDataForm {
  DFormId: string;
  cfgDForm: FormConfigurationModel;
  dataFormParagraphs: FormParagraphDataModel[];
  enumFormCompletionStatus: EnumValidValueItemModel;
}

@Component({
  selector: 'app-forms-form',
  templateUrl: './forms-form.component.html',
  styleUrls: ['./forms-form.component.css']
})

export class FormsFormComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('masterFormContainer') masterFormContainerRef: ElementRef;

  @Input() dataForm: PatientCaseWorkItemFormDataModel;
  @Input() cfgFormVersion: FormVersionConfigurationModel;
  // @Input() dataFormID: string = '01137b7d-6579-4f09-8e4c-3f1e753b4d9e';
  @Input() CaseWorkItemFormsId: string;  // AKA: dataFormID per brandon
  @Input() isPreviewMode: boolean = false;
  @Input() saveEnabled: boolean = true;
  @Input() actionsEnabled: boolean = true;
  @Input() colorGuides: boolean = false;
  @Input() absolutePosition: boolean = false;

  @Output() formHasSaved: EventEmitter<any> = new EventEmitter();

  isPatient: boolean = false;
  hoverLoading: boolean = false;
  generatingPdf: boolean = false;

  containerDimensions: any = {
    height: -1,
    width: -1,
  };

  saveEmitter: EventEmitter<any> = new EventEmitter();

  hasPageBreak: boolean = false;
  pageBreakArray: FormParagraphDataModel[][] = [];
  pageBreakIndex: number = 0;

  paragraphStep: number = 0;
  messageSubscription: any;
  needsSavingCount: number = 0;
  itemsRequired = new Map();
  isSaving: boolean = false;
  isLoading: boolean = false;
  listenToChanges: boolean = false;

  containerSizeInterval: any;

  repeatingParagraph: FormParagraphConfigurationModel;
  formSubscription: Subscription;
  isSubmissionRequired: boolean = false;

  isFormLocked: boolean = false;
  constructor(
    private readonly formsService: FormsService,
    public readonly formsGlobals: FormsGlobals,
    private readonly messagingService: MessagingService,
    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    private readonly staticDataService: StaticDataService,
    private readonly globals: Globals
  ) {

  }

  async ngOnInit() {

  }

  async ngOnDestroy() {
    this.messageSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.buildView();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('FormsFormComponent ngOnChanges', changes);
    if (changes.CaseWorkItemFormsId && this.listenToChanges) {
      if (changes.CaseWorkItemFormsId.currentValue !== null) {
        this.isLoading = true;
        this.execgetDataForm();
      }
    }
  }

  async buildView() {
    const isPatientRole = localStorage.getItem('isPatientRole');
    if (isPatientRole && isPatientRole === 'true') {
      this.isPatient = true;
    }


    this.messageSubscription = this.messagingService.componentMessageCall
      .subscribe(response => {
        // console.log('FormsFormComponent componentMessageCall this.itemsRequired:', this.itemsRequired.size, response.event);
        switch (response.event) {
          case `FORMS_ITEM_NEEDS_SAVE_${this.CaseWorkItemFormsId}`:
            this.needsSavingCount++;
            break;
          case `FORMS_OPEN_SUMMARY_${this.CaseWorkItemFormsId}`:
            this.openFormsSummary(response.data.summaryParagraph);
            break;
          case `FORMS_ITEM_HAS_SAVED_${this.CaseWorkItemFormsId}`:
            this.needsSavingCount--;

            if (this.needsSavingCount === 0) {
              this.hoverLoading = false;
              this.formHasSaved.emit(true);

              this.snackBar.open('Form saved', 'Success', {
                duration: 3000,
                verticalPosition: 'top'
              });
            }
            break;
          case `FORMS_PARAGRAPH_IS_SAVING_${this.CaseWorkItemFormsId}`:
            this.isSaving = response.data.isSaving;
            break;
          case `FORMS_ITEM_REQUIRED_${this.CaseWorkItemFormsId}`:
            // console.log('FormsFormComponent FORMS_ITEM_REQUIRED_', response.data.required);
            if (response.data.required) {
              this.itemsRequired.set(response.data.dataFormItemId, response.data.required);
            }
            else {
              this.itemsRequired.delete(response.data.dataFormItemId);
            }
            break;
          case 'FORMS_RELOAD_CURRENT_FORM':
            this.reloadForm();
            break;
        }
      });

    await this.gatherContainerDimensions();

    if (this.isPreviewMode) {
      this.isLoading = true;
      this.formsService.createSpoofDataForm(this.cfgFormVersion)
        .subscribe((response: PatientCaseWorkItemFormDataModel) => {
          this.dataForm = response;
          this.sortParagraphs();
          this.setUpInitialPageBreak();
          this.checkForMobileView();
          this.isLoading = false;
        }, err => {
          console.log(err);
        });
    }
    else {
      console.log('FormsFormComponent build view dataForm', this.dataForm);
      if (this.dataForm === undefined) {
        this.isLoading = true;
        this.execgetDataForm();
      } else {
        // console.log('FormsFormComponent build view dataForm', this.dataForm);
        this.sortParagraphs();
        this.setUpInitialPageBreak();
        this.checkForMobileView();
        this.isLoading = false;
      }
    }
  }

  checkForMobileView() {
    /*
    * Now we determine if the form will fit in the current container
    * If not, we need to make it 'mobile friendly'
    * Turn all Vertical paragraphs into horizontal
    * Rows that do not fit within the width of the container need to be split on new lines
    * use this.dataForm
    *
    *
    *
    */
  }

  openFormsSummary(summaryParagraph) {
    const dialogRef = this.dialog.open(FormsSummaryComponent, {
      width: '1500px',
      height: '95%',
      data: {
        summaryParagraph,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  async gatherContainerDimensions() {
    //console.log('FormsFormComponent gathercontainerdimentions');
    const newContainer = new ContainerModel();

    const bounds = this.masterFormContainerRef.nativeElement.getBoundingClientRect();
    newContainer.width = bounds.width;
    newContainer.height = bounds.height;

    const promise = new Promise<void>((resolve, reject) => {

      this.containerSizeInterval = setInterval(_ => {
        try {

          const mainFormContainerElement = document.getElementById('master-form-container');
          const width = mainFormContainerElement.offsetWidth;
          const height = mainFormContainerElement.offsetHeight;

          this.containerDimensions.width = width;
          this.containerDimensions.height = height;

          if (this.containerSizeInterval) {
            clearInterval(this.containerSizeInterval);
          }

          resolve(null);
        } catch (e) {
          // wait for it to try again
        }
      }, 200);
    });
    return promise;
  }

  execgetDataForm() {

    console.log('FormsFormComponent getDataForm');
    this.isLoading = true;

    if (this.CaseWorkItemFormsId) {
      // console.log('FormsFormComponent getDataForm with CaseWorkItemFormsId', this.CaseWorkItemFormsId);
      this.formsService.getDataForm(this.CaseWorkItemFormsId)
        .subscribe((response: PatientCaseWorkItemFormDataModel) => {
          setTimeout(() => {
            this.itemsRequired = new Map();
            this.loadFormResponse(response);
            this.isLoading = false;
          }, 1);
        }, err => {
          this.listenToChanges = true;
          this.isLoading = false;
          console.log(err);
        });
    } else {
      const interval = setInterval(() => {
        if (this.CaseWorkItemFormsId) {
          clearInterval(interval);
          this.formsService.getDataForm(this.CaseWorkItemFormsId)
            .subscribe((response: PatientCaseWorkItemFormDataModel) => {
              this.loadFormResponse(response);
              this.isLoading = false;
            }, err => {
              clearInterval(interval);
              this.listenToChanges = true;
              this.isLoading = false;
              console.log(err);
            });
        }
      }, 200);
    }
  }

  reloadForm() {
    // console.log('FormsFormComponent reloadForm submissionrequired: ', this.formsService.currentForm.cfgDForm.isSubmissionRequired);

    this.loadFormResponse(this.formsService.currentForm);
  }

  loadFormResponse(formResponse: PatientCaseWorkItemFormDataModel) {
    this.dataForm = null;
    for (const para of formResponse.dataFormParagraphs) {
      if (para.cfgDFormParagraph?.isRepeting) {
        this.repeatingParagraph = para.cfgDFormParagraph;
        break;
      }
    }
    this.listenToChanges = true;
    this.needsSavingCount = 0;
    this.dataForm = formResponse;
    this.isFormLocked = this.dataForm.enumFormCompletionStatusID == this.formsGlobals.STATUS_COMPLETED || this.dataForm.enumFormCompletionStatusID == this.formsGlobals.STATUS_COMPLETEDANDSIGNED;
    this.isSubmissionRequired = this.dataForm.isSubmissionRequired || this.dataForm.cfgDForm.isSubmissionRequired;  

    //console.log('FormsFormComponent loadFormResponse dataform', this.dataForm);
    this.sortParagraphs();
    this.setUpInitialPageBreak();
    this.checkForMobileView();
    //this.setActionButtonsVisibility();
    // console.log('FormsFormComponent setActionButtonsVisibility set timer');
    setTimeout(_ => {
      // console.log('FormsFormComponent setActionButtonsVisibility run timer');
      this.setActionButtonsVisibility();
    }, 200);


  }

  setActionButtonsVisibility() {
     console.log('FormsFormComponent setActionButtonsVisibility, required:', this.isSubmissionRequired);
     
    const collection = document.querySelectorAll<HTMLElement>(".form-item-action-button");
    // console.log('FormsFormComponent setActionButtonsVisibility collection', collection);
    for (let i = 0; i < collection.length-1; i++) {
      collection[i].style.display = "none";
    }
    if (collection.length > 0) 
      collection[collection.length-1].style.display = "block";

    const deleteActions = document.querySelectorAll<HTMLElement>(".form-item-action-button-delete");
    // console.log('FormsFormComponent setActionButtonsVisibility deleteActions', deleteActions);

    if (deleteActions.length === 1) {
      deleteActions[0].style.display = "none";
    }
  }
  setParagraphStep(i) {
    this.paragraphStep = i;
  }

  setUpInitialPageBreak() {
    // console.log('FormsFormComponent setUpInitialPageBreak');

    this.pageBreakArray = [];
    let tmpParagraphArray: FormParagraphDataModel[] = [];
    this.dataForm.dataFormParagraphs.forEach(paragraph => {
      tmpParagraphArray.push(paragraph);
      if (paragraph.cfgDFormParagraph.PageBreakAfter) {
        this.hasPageBreak = true;
        this.pageBreakArray.push(tmpParagraphArray);
        tmpParagraphArray = [];
      }
    });
    if (this.hasPageBreak) {
      if (tmpParagraphArray.length) {
        this.pageBreakArray.push(tmpParagraphArray);
      }
      this.pageBreakIndex = 0;
    }
  }

  overwriteParagraphs() {
    // this.pageBreakArray.forEach((paragraphGroup: dataFormParagraph4Forms[]) => {
    //  paragraphGroup.forEach((paragraph: dataFormParagraph4Forms) => {
    //    this.dataForm.dataFormParagraphs.forEach(dFormParagraph => {
    //      if (paragraph.dataFormParagraphID == dFormParagraph.dataFormParagraphID) {
    //        console.log('overwriting', dFormParagraph, 'with', paragraph);
    //        dFormParagraph = paragraph;
    //      }
    //    });
    //  });
    // });
  }

  nextPageBreak(mode: string) {
    this.overwriteParagraphs();
    if (mode === 'next') {
      this.pageBreakIndex++;
    } else {
      this.pageBreakIndex--;
    }
  }

  sortParagraphs() {
    // console.log('FormsFormComponent sortParagraphs:', JSON.parse( JSON.stringify(this.dataForm.dataFormParagraphs)));
    this.dataForm.dataFormParagraphs = this.dataForm.dataFormParagraphs.sort((a, b) => {
      if (a.cfgDFormParagraph.ParagraphOrder === b.cfgDFormParagraph.ParagraphOrder) {
        const d1 = moment(a.xauditCreatedOn);
        const d2 = moment(b.xauditCreatedOn);
        return d1.diff(d2);
      }
      return a.cfgDFormParagraph.ParagraphOrder - b.cfgDFormParagraph.ParagraphOrder;
    });

    // console.log('FormsFormComponent sortParagraphs SORTED:', JSON.parse( JSON.stringify(this.dataForm.dataFormParagraphs)));

  }

  saveForm() {
    //console.log('FormsFormComponent saveForm');
    this.needsSavingCount = 0;
    this.hoverLoading = true;
    this.saveEmitter.emit(true);
  }

  completeForm() {
    //console.log('FormsFormComponent completeForm');
    this.isLoading = true;
    this.formsService.completeForm(this.dataForm.DFormId, this.CaseWorkItemFormsId)
      .subscribe((response: any) => {
        //console.log('FormsFormComponent completeForm response', response);
        this.isLoading = false;
        if (response) {
          //console.log('FormsFormComponent completeForm response:', response);
          if (response.success) {

            this.messagingService.sendComponentMessage(MessagingConstants.RELOAD_PATIENT_FORMS, {});
            this.isFormLocked = true;
            this.dataForm.enumFormCompletionStatusID = this.formsGlobals.STATUS_COMPLETED;
          }
          else {
            this.snackBar.open(`Error completing form: ${response.message}`, 'Error', {
              duration: 5000,
              verticalPosition: 'top'
            });
          }
        }
      }, err => {
        console.log("Error completing form", err);
        this.listenToChanges = true;
        this.isLoading = false;
        this.isFormLocked = false;
        // console.log(err);
        this.snackBar.open(`Error completing form: ${err.error.Message}`, 'Error', {
          duration: 5000,
          verticalPosition: 'top'
        });

      });
  }

  generatePDF() {
    //console.log('FormsFormComponent generatePDF');
    // need to split up the form into pages
    // need to limit the width or scroll out so that it fits
    // need to auto scroll to next section

    this.generatingPdf = true;
    const hasPageBreakBefore = this.hasPageBreak;
    this.hasPageBreak = false;

    // TODO: Why is a timer necessary here???
    setTimeout(_ => {
      html2canvas(document.querySelector('#main-form-container')).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        const doc = new jspdf('p', 'mm');
        let position = 10; // give some top padding to first page

        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position += heightLeft - imgHeight; // top padding for other pages
          doc.addPage();
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save(`${this.dataForm.cfgDForm.DFormName}.pdf`);

        this.generatingPdf = false;
        this.hasPageBreak = hasPageBreakBefore;
      });
    }, 2000);
  }

  // Passing event back to form level so all items can be looped through
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  onSaveDataNote(noteCategoryId: string) {
    //console.log('FormsFormComponent saveDataNote');
    let note: string = '';
    const allControlsForNotes: NotesFromFormModel[] = [];
    for (const para of this.dataForm.dataFormParagraphs) {
      const controlsForNotes = para.dataFormItems.filter(p => this.formsGlobals.controlIdsForNotes.includes(p.cfgDFormItem.enumFormControlID));
      for (const item of controlsForNotes) {
        const parent = para.dataFormItems.find(p => p.cfgDFormItem.DFormItemId === item.cfgDFormItem.ParentDFormItemId);
        if (parent) {
          let model = allControlsForNotes.find(p => p.parentItem === parent);
          if (!model) {
            model = new NotesFromFormModel();
            model.parentItem = parent;
            allControlsForNotes.push(model);
          }
          model.children.push(item);
        }
      }
    }

    for (const model of allControlsForNotes) {
      if (model.children.length === 0) {
        continue;
      }

      model.children = model.children.sort((a, b) => {
        return a.cfgDFormItem.ParagraphRow - b.cfgDFormItem.ParagraphRow;
      });

      let label = '';
      let values = '';
      label += model.parentItem.cfgDFormItem.Label;

      if (label.length === 0) {
        continue;
      }

      for (const item of model.children) {
        switch (item.cfgDFormItem.enumFormControlID) {
          case this.formsGlobals.CONTROL_CHECK_BOX:
            if (model.children.length === 1) {
              // Single checkbox with no label associated to it
              if (model.children[0].dataFormResults &&
                model.children[0].dataFormResults.length > 0 &&
                model.children[0].dataFormResults[0].Result &&
                model.children[0].dataFormResults[0].Result.length > 0) {
                if (model.children[0].dataFormResults[0].Result.toLowerCase() === 'true') {
                  values += model.parentItem.cfgDFormItem.Label;
                }
              }
            } else {
              // Many checkboxes, with their own labels, associated to a parent label
              for (const result of item.dataFormResults) {
                if (result.Result.toLowerCase() === 'true') {
                  if (item.cfgDFormItem.Label && item.cfgDFormItem.Label.length > 0) {
                    values += item.cfgDFormItem.Label + '\r\n';
                  } else {
                    if (result.Result && result.Result.length > 0) {
                      values += result.Result + '\r\n';
                    }
                  }
                }
              }
            }
            break;
          case this.formsGlobals.CONTROL_TEXT_BOX:
            if (item.dataFormResults && item.dataFormResults.length > 0) {
              values += item.dataFormResults[0].Result + '\r\n';
            }
            break;
          case this.formsGlobals.CONTROL_COMBO_LIST:
            if (item.dataFormResults && item.dataFormResults.length > 0) {
              const comboRes = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === item.dataFormResults[0].Result);
              if (comboRes) {
                values += comboRes.ItemDisplayValue + '\r\n';
              }
            }
            break;
          case this.formsGlobals.CONTROL_RADIO_LIST:
            if (item.RESULT) {
              const comboRes = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === item.RESULT.Result);
              if (comboRes) {
                values += comboRes.ItemDisplayValue + '\r\n';
              }
            }
            break;
          case this.formsGlobals.CONTROL_CHECK_BOX_LIST:
            if (item.dataFormResults && item.dataFormResults.length > 0) {
              for (const result of item.dataFormResults) {
                values += result.Result + '\r\n';
              }
            }
            break;
        }
      }

      if (values === label) {
        if (note.length > 0) {
          note += '\r\n';
        }
        note += label + '\r\n';
      } else {
        if (values.length > 0) {
          if (note.length > 0) {
            note += '\r\n';
          }

          if (label.includes(':')) {
            note += label + '\r\n';
          } else {
            note += label + ':\r\n';
          }
          note += values;
        }
      }
    }

    if (note.length > 0) {
      const model = new TdoNoteSaveModel();
      model.patientId = this.globals.currentPatientId;

      const associatedObjects = [];
      const newAssociatedObjectCase = new TdoNoteAssociatedObject();
      newAssociatedObjectCase.objectId = this.globals.currentPatientCaseId;
      newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
      associatedObjects.push(newAssociatedObjectCase);

      model.associatedObjects = associatedObjects;
      model.categoryEnumIds.push(noteCategoryId);
      model.typeEnumIds.push('00000019-1000-0000-0000-000000000002');

      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_CREATE_NOTE, model);
    }
  }

}
